export default __webpack_public_path__ + "static/media/sd-photo.9f8e72d5.jpg";